import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { itineraryCurrentPageHiddenSelector, itineraryCurrentPageEmptySelector } from 'store/itinerariesItem/selectors';
import { updateLandingPageHiddenValueThunk } from 'store/itinerariesItem/thunks';

function useItem(props) {
  const { pageIndex } = props;
  const dispatch = useDispatch();
  const [showEyeIcon, setShowEyeIcon] = React.useState(false);
  const pageHidden = useSelector((state) => itineraryCurrentPageHiddenSelector(state, pageIndex));
  const pageEmpty = useSelector((state) => itineraryCurrentPageEmptySelector(state, pageIndex));
  const hidden = pageHidden || pageEmpty;

  const handleToggleEyeClick = (event) => {
    event.stopPropagation();
    if (pageEmpty) return;
    dispatch(updateLandingPageHiddenValueThunk({ pageIndex, hidden: !hidden }));
  };

  return { hidden, empty: pageEmpty, showEyeIcon, setShowEyeIcon, handleToggleEyeClick };
}

export default useItem;
